import { render, staticRenderFns } from "./_DoInsurancePrice.vue?vue&type=template&id=a40e360c"
import script from "./_DoInsurancePrice.vue?vue&type=script&lang=js"
export * from "./_DoInsurancePrice.vue?vue&type=script&lang=js"
import style0 from "./_DoInsurancePrice.vue?vue&type=style&index=0&id=a40e360c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports